import { useEffect, useState, type PointerEvent } from "react";
import type { Action, InputManager } from "../main/InputManager";

function Pad({ input, action, label, className }: { input: InputManager; action: Action; label: string; className: string }) {
  const down = (e: PointerEvent) => {
    e.preventDefault();
    e.currentTarget.setPointerCapture(e.pointerId);
    input.setTouch(action, true);
  };
  const up = (e: PointerEvent) => {
    e.preventDefault();
    input.setTouch(action, false);
  };
  return (
    <button className={`touch ${className}`} onPointerDown={down} onPointerUp={up} onPointerCancel={up} onLostPointerCapture={up} onContextMenu={(e) => e.preventDefault()} aria-label={label}>
      {label}
    </button>
  );
}

/** On-screen controls for touch devices (§7.1 InputManager). */
export function TouchControls({ input, disabled = false }: { input: InputManager; disabled?: boolean }) {
  const [turbo, setTurbo] = useState(false);
  useEffect(() => {
    input.setTouch("FAST_FORWARD", turbo && !disabled);
    return () => input.setTouch("FAST_FORWARD", false);
  }, [input, turbo, disabled]);
  useEffect(() => { if (disabled) setTurbo(false); }, [disabled]);
  useEffect(() => () => { for (const key of ["UP", "DOWN", "LEFT", "RIGHT", "A", "B", "START", "SELECT", "FAST_FORWARD"] as Action[]) input.setTouch(key, false); }, [input, disabled]);
  useEffect(() => {
    const reset = () => setTurbo(false);
    window.addEventListener("blur", reset);
    document.addEventListener("visibilitychange", reset);
    return () => { window.removeEventListener("blur", reset); document.removeEventListener("visibilitychange", reset); };
  }, []);
  return (
    <div className="touch-controls" aria-label="Touch controls" {...(disabled ? { inert: "" } : {})}>
      <div className="dpad">
        <Pad input={input} action="UP" label="▲" className="up" />
        <Pad input={input} action="LEFT" label="◀" className="left" />
        <Pad input={input} action="RIGHT" label="▶" className="right" />
        <Pad input={input} action="DOWN" label="▼" className="down" />
      </div>
      <div className="meta">
        <Pad input={input} action="SELECT" label="SELECT" className="pill" />
        <Pad input={input} action="START" label="START" className="pill" />
        <button className="touch pill turbo-toggle" aria-pressed={turbo} onClick={() => setTurbo(v => !v)}>Turbo {turbo ? "ON" : "OFF"}</button>
      </div>
      <div className="ab">
        <Pad input={input} action="B" label="B" className="b" />
        <Pad input={input} action="A" label="A" className="a" />
      </div>
    </div>
  );
}
